<template>
  <div id="desk" class="lg:flex">
    <div class="flex p-0 lg:flex-grow">
      <div class="flex flex-col flex-1 my-0 mx-auto max-w-6xl">
        <div class="p-0 pb-0 lg:px-10 lg:pt-12 lg:flex">
          <desk-tasks/>
          <desk-notes/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeskNotes from '@/components/DeskNotes'
import DeskTasks from '@/components/DeskTasks'

export default {
  name: 'Desk',
  components: {
    DeskNotes,
    DeskTasks
  }
}
</script>
